import CheckInSkipTheCounterBridge from './CheckInSkipTheCounterBridge';

export default CheckInSkipTheCounterBridge;
